import { SxProps, Theme } from '@mui/material/styles';
import { getTypographyVariants } from '@theme/styleOverrides';

// THEME TODO:
// move into theme/stye overrides and get access to fontsize
const cellStyle = {
  fontWeight: 'normal',
  '&:focus': {
    outline: 'none',
  },
  '&:focus-within': {
    outline: 'none',
  },
};

const columnStyle = {
  '& .MuiDataGrid-withBorderColor': {
    borderColor: 'transparent',
  },
  '& .MuiDataGrid-columnHeader:focus': {
    outline: 'none',
  },
  '& .MuiDataGrid-columnHeaderTitle': {
    fontSize: (theme: Theme) => getTypographyVariants(theme.palette.fontSize).tableHeader.fontSize,
    lineHeight: (theme: Theme) => getTypographyVariants(theme.palette.fontSize).tableHeader.lineHeight,
    textTransform: (theme: Theme) => getTypographyVariants(theme.palette.fontSize).tableHeader.textTransform,
    color: 'text.subdued',
    fontWeight: (theme: Theme) => getTypographyVariants(theme.palette.fontSize).fontWeightBold,
  },
  '& .MuiDataGrid-columnSeparator--sideRight': {
    display: 'none',
  },
  '& .MuiDataGrid-columnHeader': {
    '&:focus': {
      outline: 'none',
    },
    '&:focus-within': {
      outline: 'none',
    },
  },
} as const;

const paginationStyle = {
  '& .MuiTablePagination-root': {
    borderBottom: 'none',
  },
};

const hoverStyle = {
  '& .MuiDataGrid-row:hover': {
    backgroundColor: 'inherit',
  },
} as const;

const dataGrid = {
  border: 'none',
  '& .MuiDataGrid-cell': {
    ...cellStyle,
  },
  '--DataGrid-rowBorderColor': (theme: Theme) => theme.palette.border.main,

  '& .MuiDataGrid-cell--editable': {
    padding: '0px !important',
    boxShadow: 'none !important',
    outline: 'none !important',
  },

  '& .MuiDataGrid-row.Mui-selected': {
    backgroundColor: 'transparent',
    '&:hover': {
      backgroundColor: 'transparent',
    },
  },

  '--unstable_DataGrid-overlayBackground': (theme: Theme) =>
    theme.palette.theme === 'lio' ? 'rgba(255, 255, 255, 0.38)' : 'rgba(18, 18, 18, 0.1)',

  ...columnStyle,
  ...paginationStyle,
  ...hoverStyle,
} as const;

const dataGridContainer = {
  backgroundColor: (theme: Theme) => theme.palette.dataGrid?.background ?? theme.palette.background.light,
  borderRadius: '8px',
  borderLeftWidth: '8px',
  display: 'flex',
  flexDirection: 'column',
  width: '100%',
  padding: '16px',
  borderLeft: `8px solid`,
  borderColor: 'dataGrid.borderLeft',
  '@media only screen and (max-width: 600px)': {
    borderLeft: 'none',
  },
} as SxProps;

const portalAdminDataGrid = {
  ...dataGrid,
  '& .MuiDataGrid-columnHeaders': {
    borderTop: `1px inset`,
    borderColor: 'border.main',
  },
};

const subjectivitiesDataGrid = {
  ...portalAdminDataGrid,
};

const hoverablePortalAdminDataGrid = {
  ...portalAdminDataGrid,
  '& .MuiDataGrid-row': {
    cursor: 'pointer',
    '&:hover': {
      backgroundColor: '#F5F5F5',
    },
  },
};

const ratingSummaryDataGrid = {
  ...dataGrid,
  height: 'fit-content',
  '& .MuiDataGrid-row': {
    border: 'none',
  },
  '& .MuiDataGrid-cell': {
    border: 'none',
    '&:focus': {
      outline: 'none',
    },
    '&:focus-within': {
      outline: 'none',
    },
  },
  '& .MuiDataGrid-columnHeaders': {
    border: 'none',
    marginBottom: '16px',
  },
};

export {
  dataGrid,
  dataGridContainer,
  cellStyle,
  subjectivitiesDataGrid,
  portalAdminDataGrid,
  hoverablePortalAdminDataGrid,
  ratingSummaryDataGrid,
};
